// extracted by mini-css-extract-plugin
export var container = "_3n-0";
export var error = "_3n-9";
export var label = "_3n-5";
export var light = "_3n-6";
export var md = "_3n-3";
export var sm = "_3n-2";
export var thin = "_3n-8";
export var thinBold = "_3n-7";
export var vertical = "_3n-4";
export var xs = "_3n-1";